import { graphql } from "~/gql";

export const DELETE_TASK = graphql(/* GraphQL */ `
  mutation deleteTask($taskId: Float!) {
    deleteTask(taskId: $taskId) {
      taskId
    }
  }
`);

export const DELETE_TASKS = graphql(/* GraphQL */ `
  mutation deleteTasks($phaseId: Float!) {
    deleteTasks(phaseId: $phaseId) {
      tasksIds
    }
  }
`);
